























import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import Card from './Card.vue';

@Component({
    components: {
        Card
    }
})
export default class TestimonialCard extends Vue {
    left: number;
    top: number;
    @Prop({default: 'Tim Johnson', type: String}) cardTitle: string;
    @Prop({default: 'France', type: String}) cardCountry: string;
    @Prop({default: 0, type: Number}) translateX: number;
    @Watch('translateX', { immediate: true, deep: true })
    changebackground(val: number, oldVal: number) {
        let interval = setInterval(() => {
            this.changeBackground();
        }, 0);
        setTimeout(() => {
            clearInterval(interval);
        }, 150);
    }

    /**
     *
     */
    constructor() {
        super();
        this.left = 0;
        this.top = 0;
    }

    mounted (): void {
        
        var rect = this.$el.getBoundingClientRect();
        this.left = -rect.left;
        this.top = -286.7;
        window.addEventListener("resize", () => {
            var rect = this.$el.getBoundingClientRect();
            this.left = -rect.left;
        });
    }

    changeBackground() {
        var rect = this.$el.getBoundingClientRect();
        this.left = -rect.left;
    }
}
